// extracted by mini-css-extract-plugin
export default {"Label":"label_Label__46Vgv"};